import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { User } from '../../domain/interfaces/User.interface';
import { API_BASE_URL, SANCTUM_URL } from 'src/environments/environment.prod';

@Injectable({
  providedIn: 'root'
})
export class AuthApiService {

  private readonly http = inject(HttpClient)
  private readonly PATH = ''

  constructor() { }

  public async login(email: string, password: string): Promise<any> {

    await firstValueFrom(this.http.get<any>(`${SANCTUM_URL}`));

    return firstValueFrom(
      this.http.post<any>(`${API_BASE_URL}/login`, { email, password })
    )
  }

  public async logout(): Promise<void> {
    return firstValueFrom(this.http.post<void>(`${API_BASE_URL}/logout`, {}))
  }

  public async forgotPassword(email: string): Promise<void> {
    return firstValueFrom(this.http.post<void>(`${API_BASE_URL}/forgot-password`, { email }))
  }

  public async resetPassword(token: string, password: string, confirmPassword: string, email: string): Promise<void> {
    return firstValueFrom(this.http.post<void>(`${API_BASE_URL}/reset-password`,
      {
        token,
        password,
        passwordConfirmation: confirmPassword,
        email
      }
    ));
  }
}
